import { useRef } from 'react';
import MuiButtonBase from '@mui/material/ButtonBase';
import { useToggle } from '@/hooks/useToggle';
import { CaretDownIcon } from '@/icons';
import PlaybackSpeedMenu, {
  type PlaybackSpeedMenuProps,
  type Speed,
} from '@/menus/PlaybackSpeedMenu';
import { classes, formatSpeed, styles } from './utils';

export type { Speed };

export type PlaybackSpeedButtonProps = {
  speed: PlaybackSpeedMenuProps['speed'];
  onChange: PlaybackSpeedMenuProps['onChange'];
};

export default function PlaybackSpeedButton({
  speed,
  onChange,
}: PlaybackSpeedButtonProps) {
  const buttonRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle();

  return (
    <>
      <MuiButtonBase
        ref={buttonRef}
        sx={styles.button}
        className={classes.button}
        onClick={() => toggleMenu()}>
        <label className={classes.label}>{formatSpeed(speed)}</label>
        <CaretDownIcon className={classes.caret} />
      </MuiButtonBase>
      {isMenuOpen && <PlaybackSpeedMenu speed={speed} onChange={onChange} />}
    </>
  );
}
